// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LeftBlock_wrapper__ryqfk","title":"LeftBlock_title__IOCoG","description":"LeftBlock_description__cM0IG","button":"LeftBlock_button__CVJhy","icon":"LeftBlock_icon__uo5Ck"};